import React from "react";

const ProductAccessScreen = ({ isCheckingAccess, hasAccess }) => {
  return (
    <>
      {isCheckingAccess ? (
        <div className="z-[99999] w-screen h-screen fixed top-0 left-0 bg-white grid place-items-center">
          <p>Loading...</p>
        </div>
      ) : hasAccess ? (
        <></>
      ) : (
        <div className="z-[99999] w-screen h-screen fixed top-0 left-0 bg-white grid place-items-center">
          <p className="font-bold">403: You do not have access to this product.</p>
        </div>
      )}
    </>
  );
};

export default ProductAccessScreen;
